jQuery(document).ready(function ($) {
  setTimeout(function() {
    FrontChat('identity', {
      name: WP.niceName
    });
  }, 1000);

  $(document).on("click", "[data-front-chat]", (e) => {
    e.preventDefault();
    FrontChat('show');
  });
});

